import { Link } from 'react-router-dom';
import { Instagram, Music2 } from 'lucide-react';
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Footer() {
  const [email, setEmail] = useState('');
  const submit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success('Iscrizione completata. Usa il codice ESSENYA10 al checkout.');
      setEmail('');
    } catch { toast.error('Email non valida'); }
  };

  return (
    <footer data-testid="site-footer" className="bg-essenya-ink text-white mt-24">
      <div className="container-essenya py-20 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="font-display text-2xl tracking-[0.18em] mb-4">ESSENYA</div>
          <p className="text-white/70 mb-6 max-w-sm">Una casa pulita. Un profumo che resta.</p>
          <form onSubmit={submit} className="flex gap-2" data-testid="footer-newsletter-form">
            <input
              data-testid="footer-newsletter-input"
              value={email} onChange={e => setEmail(e.target.value)}
              type="email" required placeholder="La tua email"
              className="flex-1 bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-sm placeholder:text-white/50 focus:outline-none focus:border-white"
            />
            <button data-testid="footer-newsletter-submit" className="bg-white text-essenya-ink px-5 rounded-lg font-medium hover:bg-essenya-champagne transition">Iscriviti</button>
          </form>
          <p className="text-white/40 text-xs mt-3">Niente spam. Solo novità, consigli e offerte utili.</p>
        </div>
        <div className="md:col-span-2">
          <h4 className="text-eyebrow text-white/60 mb-4">Shop</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/shop">Tutti i prodotti</Link></li>
            <li><Link to="/lavapavimenti">Lavapavimenti</Link></li>
            <li><Link to="/sgrassatori">Sgrassatori</Link></li>
            <li><Link to="/bundle">Bundle</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <h4 className="text-eyebrow text-white/60 mb-4">Brand</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/chi-siamo">Chi siamo</Link></li>
            <li><Link to="/come-si-usa">Come si usa</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
            <li><Link to="/contatti">Contatti</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <h4 className="text-eyebrow text-white/60 mb-4">Assistenza</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/tracking">Traccia ordine</Link></li>
            <li><Link to="/faq">Spedizioni</Link></li>
            <li><Link to="/faq">Resi e rimborsi</Link></li>
            <li><Link to="/faq">Privacy Policy</Link></li>
            <li><Link to="/faq">Cookie Policy</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <h4 className="text-eyebrow text-white/60 mb-4">Seguici</h4>
          <div className="flex gap-3">
            <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-essenya-ink transition" aria-label="Instagram"><Instagram size={18} strokeWidth={1.5} /></a>
            <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-essenya-ink transition" aria-label="TikTok"><Music2 size={18} strokeWidth={1.5} /></a>
          </div>
          <p className="text-white/40 text-xs mt-6">Pagamenti sicuri<br/>Visa · Mastercard · PayPal · Apple Pay</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-white/50 text-xs text-center">© {new Date().getFullYear()} ESSENYA. Made in Italy.</div>
    </footer>
  );
}
